import { Component } from '@angular/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	title = 'swipe4win';

	public navbarOpen: boolean = false;

	constructor() { }

	toggleNavbar() {
		this.navbarOpen = !this.navbarOpen;
	}

	closeNavbar() {
		this.navbarOpen = false;
	}

}
